





















import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  DoceboCourseStatus,
  DoceboEnrolmentStatus,
  DoceboLoEnrolmentStatus,
} from '@/lib/DoceboAPI';
import { HealthForceGoSkill } from '@/lib/HealthForceGoAPI';
import calculateExpiryStatus, {
  ExpiryStatus,
} from '@/lib/calculateExpiryStatus';

@Component
export default class CourseStatus extends Vue {
  @Prop() status!:
    | DoceboLoEnrolmentStatus
    | DoceboEnrolmentStatus
    | DoceboCourseStatus
    | null;

  @Prop() skills!: HealthForceGoSkill[] | null;

  private get enrolmentStatusClasses() {
    return {
      'course-status__enrolment-status--completed': this.status === 'completed',
      'course-status__enrolment-status--failed': this.status === 'failed',
    };
  }

  private get enrolmentStatusText(): string {
    switch (this.status) {
      case 'completed': {
        return 'Completed';
      }
      case 'in-progress':
      case 'in_progress': {
        return 'In Progress';
      }
      case 'enrolled': {
        return 'Enrolled';
      }
      case 'waiting': {
        return 'Waiting';
      }
      case 'locked': {
        return 'Locked';
      }
      case 'failed': {
        return 'Failed';
      }
      case 'not_started':
      case 'ab-initio': {
        return 'Not Started';
      }
      case null:
      case 'non_subscribed': {
        return 'Unenrolled';
      }
      default: {
        return 'Unknown';
      }
    }
  }

  private get expiryDateClasses(): string {
    const className = 'course-status__expiry-date';
    switch (this.expiryStatus) {
      case ExpiryStatus.EXPIRED: {
        return `${className}--expired`;
      }
      case ExpiryStatus.EXPIRING_SOON: {
        return `${className}--expiring-soon`;
      }
      case ExpiryStatus.EXPIRING: {
        return `${className}--expiring`;
      }
      case ExpiryStatus.NOT_EXPIRABLE:
      case ExpiryStatus.INCOMPLETE:
      default: {
        return '';
      }
    }
  }

  private get expiryDateSeverity(): string {
    if (!this.skills || !this.skills.length) return '';
    const skill = this.skills[0];
    if (!skill.hasSkill || !skill.expiryDate) return '';
    switch (this.expiryStatus) {
      case ExpiryStatus.EXPIRED: {
        return 'Expired';
      }
      case ExpiryStatus.EXPIRING_SOON: {
        return 'Expires Soon';
      }
      case ExpiryStatus.EXPIRING: {
        return 'Expires';
      }
      case ExpiryStatus.NOT_EXPIRABLE:
      case ExpiryStatus.INCOMPLETE:
      default: {
        return '';
      }
    }
  }

  private get expiryDate(): string {
    if (!this.skills || !this.skills.length) return '';
    const skill = this.skills[0];
    if (!skill.hasSkill || !skill.expiryDate) return '';
    const expiryDate = new Date(skill.expiryDate);
    return `${expiryDate.getDate()}/${
      expiryDate.getMonth() + 1
    }/${expiryDate.getFullYear()}`;
  }

  private get expiryStatus(): ExpiryStatus {
    return calculateExpiryStatus(this.skills);
  }
}
